import { Add, HistorySharp, PersonAddAlt1, Search } from "@mui/icons-material";
import { Button, Dialog, InputAdornment, TextField } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import CustomerCreationWizard from "../../../../components/Customer/CustomerCreationWizard";
import SimpleWidgetsHeader from "../../../../components/SimpleWidgetsHeader/SimpleWidgetsHeader";
import { PosContext } from "../../../../shared/PosContext";
import { parseCustomerAddress } from "../../../../utils/floorUtils";
import OrderDetailsDialog from "../OrderDetailsDialog";
import CustomerAddress from "./CustomerAddress";
import { useStyles } from "./styles";

const CustomerDialog = ({
    dialogOpen,
    onConfirm,
    onCancel,
    customerSelected,
    selectedCustomer,
}) => {
    const classes = useStyles();

    const { customers } = useContext(PosContext);

    const [customerList, setCustomerList] = useState([]);
    const [orderDetailsOpen, setOrderDetailsOpen] = useState(false);
    const toggleOrderDetails = () => setOrderDetailsOpen(!orderDetailsOpen);
    const [orderDetailsCustomer, setOrderDetailsCustomer] = useState(null);

    const [selectedCustomerName, setSelectedCustomerName] = useState(null);
    const [customerAddressOpen, setCustomerAddressOpen] = useState(false);

    const [createCustomerDialogOpen, setCreateCustomerDialogOpen] =
        useState(false);

    useEffect(() => {
        setSelectedCustomerName(null);
        setCreateCustomerDialogOpen(false);
        setCustomerAddressOpen(false);
    }, []);

    useEffect(() => {
        if (customers) {
            setCustomerList(customers);
        }
    }, [customers]);

    const handleOnClose = () => {
        setCustomerAddressOpen(false);
        if (onCancel) onCancel();
    };

    const handleChange = (newValue) => {
        const tmpList = [];

        if (!newValue) {
            setCustomerList(customers);
            return;
        }

        customers &&
            customers.map((customer) => {
                if (
                    customer.customer_name
                        ?.toLowerCase()
                        .includes(newValue.toLowerCase()) ||
                    customer.mobile_no?.includes(newValue) ||
                    customer.territory
                        ?.toLowerCase()
                        .includes(newValue.toLowerCase())
                ) {
                    tmpList.push(customer);
                }
            });
        setCustomerList(tmpList);
    };

    const onCloseCreateCustomer = () => {
        setCreateCustomerDialogOpen(false);
        setCustomerAddressOpen(false);
    };

    const showCreateCustomerDialog = () => {
        setCreateCustomerDialogOpen(true);
    };

    const onConfirmCustomerCreated = (customerName, orderData) => {
        if (customerName) {
            if (onConfirm) {
                onConfirm(customerName, orderData.address);
            }
        }

        setCreateCustomerDialogOpen(false);
    };

    // const onConfirmCustomerCreated = (customerData, addressData) => {
    //     const { name: customerName } = customerData?.data;
    //     const { name: addressName } = addressData?.data;
    //     const isTakeaway = window.location.pathname.includes("/takeaway");
    //     if (customerName) {
    //         if (onConfirm) {
    //             if (isTakeaway) {
    //                 setSelectedCustomerName(customerName);
    //                 setCustomerAddressOpen(true);
    //                 //-TODO
    //             } else {
    //             }
    //             onConfirm(customerName, addressName);
    //         }
    //     }

    //     setCreateCustomerDialogOpen(false);
    // };

    const handleCustomerSelect = (customer) => {
        const isTakeaway = window.location.pathname.includes("/takeaway");

        if (isTakeaway) {
            setSelectedCustomerName(customer.name);
            setCustomerAddressOpen(true);
        } else {
            setSelectedCustomerName(customer.name);
            customerSelected?.(customer.name);
        }
    };

    const handleAddressClose = () => {
        setCustomerAddressOpen(false);
    };

    const handleAddressSelect = (customerName, addressName) => {
        setCustomerAddressOpen(false);
        customerSelected?.(customerName, addressName);
    };

    let title = "Customers";

    if (selectedCustomer) {
        title += ` [ ${selectedCustomer} ]`;
    }

    const handleViewCustomerHistory = (customer) => {
        setOrderDetailsCustomer(customer.name);
        toggleOrderDetails();
    };

    return (
        <>
            <Dialog
                fullWidth={true}
                maxWidth={"md"}
                open={dialogOpen}
                onClose={handleOnClose}
            >
                <div className={classes.DialogWrapper}>
                    <SimpleWidgetsHeader
                        Icon={PersonAddAlt1}
                        onClose={handleOnClose}
                        title={title}
                    />
                    <div className={classes.CustomerDialogActions}>
                        <div className={classes.Input_text}>
                            <div className="Input_text__Content">
                                <TextField
                                    type="text"
                                    autoFocus
                                    placeholder="name, mobile or address"
                                    onChange={(event) =>
                                        handleChange(event.target.value)
                                    }
                                    variant="standard"
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <Search />
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                            </div>
                        </div>
                        <div className={classes.Input_text}>
                            <div className="Input_text__Content">
                                <Button
                                    onClick={() => showCreateCustomerDialog()}
                                >
                                    {" "}
                                    <Add /> New Customer
                                </Button>
                            </div>
                        </div>
                    </div>

                    <div className={classes.List}>
                        <div className="List_Header">
                            <div className="List__Row">
                                <div>Customer</div>
                                <div>Phone</div>
                                <div>Main Address</div>
                            </div>
                        </div>

                        <div className="List_Items">
                            {customerList.map((customer, index) => (
                                <div style={{ display: "flex" }}>
                                    <div
                                        key={"Customer_Row_" + index}
                                        className="List__Row"
                                        style={{ flex: 1 }}
                                        onClick={() =>
                                            handleCustomerSelect(customer)
                                        }
                                    >
                                        <div>{customer.customer_name}</div>
                                        <div>{customer.mobile_no}</div>
                                        <div>
                                            {parseCustomerAddress(customer)}
                                        </div>
                                    </div>
                                    <div
                                        key={"Customer_Row_Dialog_" + index}
                                        className="List__Row"
                                        style={{ marginLeft: "0.5rem" }}
                                        onClick={() =>
                                            handleViewCustomerHistory(customer)
                                        }
                                    >
                                        <HistorySharp />
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </Dialog>
            <Dialog
                onClose={onCloseCreateCustomer}
                open={createCustomerDialogOpen}
            >
                <CustomerCreationWizard
                    onClose={onCloseCreateCustomer}
                    onConfirm={onConfirmCustomerCreated}
                />
            </Dialog>

            <Dialog open={customerAddressOpen}>
                <CustomerAddress
                    onClose={handleAddressClose}
                    onSelect={handleAddressSelect}
                    customerName={selectedCustomerName}
                />
            </Dialog>

            <OrderDetailsDialog
                isOpen={orderDetailsOpen}
                selectedCustomer={orderDetailsCustomer}
                title={"Last Order Details"}
                toggle={toggleOrderDetails}
            />
        </>
    );
};

export default CustomerDialog;
